import { render, staticRenderFns } from "./backstock-list.vue?vue&type=template&id=5224619f&"
import script from "./backstock-list.vue?vue&type=script&lang=ts&"
export * from "./backstock-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports